import React from 'react';
import { Image } from 'antd';
import { MessageQuestionIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { setQuestionId, setTestFeedbackModal } from 'modules/global';

interface IProps {
  title?: string;
  testImage?: string;
  questionId?: number;
  checked?: string | number | null;
  subject?: string;
}

const TopSection: React.FC<IProps> = ({ title, testImage, questionId, checked, subject }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(questionId as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="text-xs text-gray-500">{subject}</div>
        <div className="flex items-center gap-2">
          {!checked && (
            <div className=" rounded-lg bg-gray-200 px-3 py-0.5 text-xs text-gray-700">{t('belgilanmagan')}</div>
          )}
          <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
            <MessageQuestionIcon />
          </div>
        </div>
      </div>
      <div className="transition-all duration-300">
        <div className="mt-3 whitespace-pre-line text-sm font-medium">{title}</div>
        {testImage && (
          <div className="mt-4 flex justify-center">
            <Image src={testImage} alt={title} loading="lazy" className="!rounded-xl" title="Test image" />
          </div>
        )}
      </div>
    </>
  );
};

export default TopSection;
